// extracted by mini-css-extract-plugin
export default {"TravellersItem":"JgS6t","header":"IWDh5","title":"mdEr9","remover":"ZHIcx","skeleton-progress":"RWuFf"};